<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.80762" y="19.7783" width="24" height="2" transform="rotate(-45 2.80762 19.7783)" fill="white"/>
    <rect x="4.2218" y="2.80762" width="24" height="2" transform="rotate(45 4.2218 2.80762)" fill="white"/>
  </svg>
</template>